<template lang="html">
    <div id="yardages">
        <empty-placeholder class="mt30 mb0" v-if="yardages.length == 0">
            TIP: Add your clubs and yardages here for quick reference on the course. Get started by
            tapping the button below.
        </empty-placeholder>

        <draggable
            :forceFallback="true"
            id="yardageList"
            handle=".handle"
            v-model="yardages"
            @end="onEnd"
        >
            <yardage-item
                :yardage="yardage"
                v-for="(yardage, index) in yardages"
                :key="yardage.id"
                :index="index"
            />
        </draggable>
        <button
            @click.prevent="addClub"
            data-cy="add club"
            type="button"
            class="button addClub"
            name="button"
        >
            Add club
        </button>
    </div>
</template>

<script>
import EmptyPlaceholder from "@/components/App/empty-placeholder";

import draggable from "vuedraggable";
import YardageItem from "@/components/Player/Yardages/Yardages-item";
import { Form } from "vform";
export default {
    name: "yardages-list",
    components: { EmptyPlaceholder, draggable, YardageItem },
    computed: {
        user() {
            return this.$store.state.user;
        },
        yardages: {
            get() {
                return this.$store.state.user.yardages;
            },
            set($value) {
                // Update the order field with the new order from drag
                var items2 = $value.map(function (item, index) {
                    return {
                        id: item.id,
                        user_id: item.user_id,
                        club: item.club,
                        yd: item.yd,
                        order: index,
                    };
                });

                this.$store.state.user.yardages = items2;
            },
        },
    },
    data() {
        return {
            form: new Form({
                order: "",
            }),
        };
    },
    methods: {
        onEnd() {
            window.axios.post("/yardages/order", { yardages: this.yardages });
        },
        addClub() {
            this.form.order = this.yardages.length + 1;
            this.form.post("/yardage").then((yardage) => {
                this.$store.dispatch("addYardageItem", yardage.data);
                /*
        this.$nextTick(()=>{
          this.$refs.bagList[this.$refs.bagList.length-1].$refs.bagItem.click();
            this.$refs.bagList[this.$refs.bagList.length-1].$refs.bagItem.focus();
        })
        */
            });
        },
    },
};
</script>

<style lang="scss">
#yardages {
    background: $grey;
    padding: 20px 0px;
    border-radius: 15px;
    padding-top: 0px;
    &.margin {
        margin-top: 20px;
        display: block;
        clear: both;
    }
    header {
        color: $green_0;
        font-size: 22px;
        margin-bottom: 20px;
        position: relative;
        .icon {
            position: absolute;
            right: 0px;
        }
    }
    .error {
        background: #ffbcbc;
        padding: 7px;
        line-height: 1.5;
        border-radius: 3px;
        display: block;
        margin-top: 10px;
        font-size: 0.8rem;
        text-align: center;
        border: 1px solid red;
        color: red;
    }
    #yardageList {
        .item {
            border-bottom: 1px solid white;
            color: $green_0;
            font-size: 16px;
            padding: 0px 10px 0px 10px;
            position: relative;
            background: $grey;

            .surround {
                pointer-events: none;
                &.allowed {
                    pointer-events: auto;
                }
            }

            i {
                float: right;
                text-align: right;
                width: 100px;
                margin-right: 20px;
                font-family: canada-type-gibson, sans-serif;
                font-weight: 200;
            }

            .yd {
                text-align: right;
                width: calc(100% - 26px);
                padding-right: 0px;
            }

            .bin {
                position: absolute;
                right: 20px;
                top: 14px;
                display: none;
            }

            input {
                background: none;
                width: calc(100% - 122px);
                display: inline-block;
                border: 0px;
                font-size: 16px;
                color: $green_0;
                padding: 11px 10px;
                font-family: canada-type-gibson, sans-serif;
                font-weight: 200;
                &:focus {
                    outline: 0;
                }
                &:disabled {
                    opacity: 1;
                    -webkit-text-fill-color: #267962;
                }

                &:nth-of-type(2) {
                    text-align: right;
                }
            }

            .handle {
                position: absolute;

                left: -11px;
                top: 0px;
                height: 100%;
                padding-left: 13px;
                padding-right: 20px;
                //padding-top: 12px;
                display: block;
                padding-top: 11px;
            }

            &.active {
                background: white;
                margin-left: -20px;
                padding-left: 30px;
                width: calc(100% + 40px);
                padding-right: 30px;
                .handle {
                    left: 9px;
                }
                .bin {
                    display: block;
                }
            }
        }
    }

    .addClub {
        margin-top: 40px;
    }
}
</style>
